import { useFormik } from "formik";
import React from "react";
import PlaceAutocomplete from "./PlaceAutocomplete";
import * as Yup from "yup";
import { APIProvider } from "@vis.gl/react-google-maps";

function HomeForm() {
  const formik = useFormik({
    initialValues: {
      zone: "",
      contract: "vendita",
      trattativa: "agenzia",
      bounds: [],
      center: [],
    },
    validationSchema: Yup.object({
      zone: Yup.string().required("Seleziona una zona"),
    }),
    validate: (values) => {
      const errors = {};
      console.log("Validating values:", values);
      if (values.bounds.length === 0) errors.zone = "Clicca su una zona";
      if (values.center.length === 0) errors.zone = "Clicca su una zona";
      return errors;
    },
    onSubmit: (values) => {
      const searchParams = new URLSearchParams({
        zone: values.zone,
        contract: values.contract,
        trattativa: values.trattativa,
        bounds: JSON.stringify(values.bounds),
        center: JSON.stringify(values.center),
      });
      const searchPageURL = homeForm.searchPageURL;
      const searchUrl = `${searchPageURL}?${searchParams.toString()}`;
      window.location.href = searchUrl;
    },
  });
  return (
    <div className="home-form uk-container uk-container-small uk-text-left">
      <div className="uk-background-muted uk-padding uk-border-rounded">
        <form className="uk-form-stacked" onSubmit={formik.handleSubmit}>
          <div className="uk-grid uk-grid-small uk-flex-bottom">
            <div className="uk-width-2-5@s uk-first-column">
              <label htmlFor="search" className="uk-label">
                Zona di ricerca
              </label>
              <APIProvider
                apiKey={"AIzaSyDd8yzaUABJy0E8cPCuD4C7CU1_kQcK6GE"}
                onLoad={() => console.log("Maps API has loaded")}
                language="it"
                region="IT"
              >
                <div className="autocomplete-control">
                  <PlaceAutocomplete
                    onChange={formik.handleChange}
                    value={formik.values.zone}
                    error={formik.errors.zone}
                    touched={formik.touched.zone}
                    onSetValue={formik.setValues}
                  />
                </div>
              </APIProvider>
            </div>
            <div className="uk-width-1-5@s">
              <label htmlFor="contract" className="uk-label">
                Tipologia contratto
              </label>
              <select
                name="contract"
                className="uk-select"
                onChange={formik.handleChange}
                value={formik.values.contract}
              >
                <option value="vendita">Vendita</option>
                <option value="affitto">Affitto</option>
              </select>
            </div>
            <div className="uk-width-1-5@s">
              <label htmlFor="trattativa" className="uk-label">
                Trattativa
              </label>
              <select
                name="trattativa"
                className="uk-select"
                onChange={formik.handleChange}
                value={formik.values.trattativa}
              >
                <option value="agenzia">Agente/Agenzia</option>
                <option value="privati">Privati</option>
              </select>
            </div>
            <div className="uk-width-expand@s">
              <button
                contract="submit"
                className="uk-button uk-button-primary uk-width-1-1"
              >
                Cerca
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default HomeForm;
